module.exports = __webpack_public_path__ + "public/media/marketeer-header.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/marketeer-header.png
// module id = ./images/services/marketeer-header.png
// module chunks = 0